import { Injectable, NgZone } from "@angular/core";
import { NavigationExtras, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { getConfig, NAVIGATE_THROUGHT_NOTIFICATION } from "src/app/core/constants/app-constants";
// import { OrderTrackModalComponent } from "src/app/modules/account/component/order-rating-modal/order-track-modal.component";
import { RatingModalComponent } from "src/app/modules/account/component/rating-modal/rating-modal.component";
import { LoginService } from "src/app/modules/modals/login-signup-modal/service/login.service";
import { AppData } from "..";

@Injectable({ providedIn: 'root' })
export class NavigationService {

  constructor(
    private ngZone: NgZone,
    private router: Router,
    private modalService: NgbModal,
    private loginService: LoginService,
  ) { }

  public navigate(commands: any[], queryString): void {
    this.ngZone
      .run(() => this.router.navigate(commands, { queryParams: queryString }))
      .then(() => {
        console.log("naviagation Success");
      });
  }

  public processNavigationOld(data) {
    // this.analyticsService.cleverTapEvent(CLEVER_TAP_EVENT.PUSH_NOTIFICATION_CLICKED, onNotificationClickedEvent(data));
    if (!AppData.isTemporary && AppData.userId && AppData.currentAddressObj) {
      console.log("processing notification for navigation");
      console.log("after clicked data: ", data);
      let options = {};
      if (data.destination === "order_tracking") {
        this.router.navigate(['order-tracking'], { queryParams: { redirectUrl: '/home' }, state: { data: data } })
        options['orderId'] = data.orderId;
      } else if (data.destination === "promo_outlet") {
        options["promoId"] = data.promoId;
        options["title"] = data.name;
      } else if (data.destination === "promo_dish") {
        options["promoId"] = data.promoId;
        options["title"] = data.name;
      } else if (data.destination === "dish" || data.destination === "outlet") {
        options["outletId"] = data.outletId;
      } else if (data.destination === "offer") {
        options["name"] = "routeType";
        options["OFFERS"] = "OFFERS";
      } else if (data.destination === "scratch_card" || data.destination === "reward") {
        options["from"] = "/home";
      } else if (data.destination === "rate_order") {
        const modalRef = this.modalService.open(
          RatingModalComponent,
          getConfig("RATING_MODAL_CONFIG")
        );
        modalRef.componentInstance.modalObj = data;
        modalRef.componentInstance.passRating.subscribe((res) => {
          console.log(res['rating']);
        })
      }

      const navigationExtras: NavigationExtras = {
        queryParams: options,
      };
      options["redirectUrl"] = window.location.pathname;
      if (data.destination !== "order_tracking" && data.destination !== "sign_up") {
        this.modalService.dismissAll();
        if (Object.keys(options).length > 0) {
          this.navigate(
            [NAVIGATE_THROUGHT_NOTIFICATION[data.destination]],
            options
          );
        } else {
          this.navigate([
            NAVIGATE_THROUGHT_NOTIFICATION[data.destination],
          ], {});
        }
      }
    } else if (!(AppData.userId || AppData.currentAddressObj)) {
      if (data.destination === "dish" || data.destination === "outlet") {
        this.navigate(["select-location"], { redirectUrl: "/welcome" });
      } else {
        this.navigate(["login"], {});
      }
    } else {
      if (data.destination === "dish" || data.destination === "outlet") {
        this.navigate(["select-location"], { redirectUrl: "/welcome" });
      } else {
        this.navigate(["login"], { fromHome: "Y", redirectUrl: window.location.pathname });
      }
    }
  }


  public processNavigation(data) {
    // 1. Check user is created
    if (!AppData.userId) {
      // Calling Explore API for creating the user.
      const reqObj = { deviceId: AppData.deviceId };
      this.loginService.exploreFirst(reqObj).then((res) => {
        const responseData = res["body"]["data"];
        console.log("Explore Service Response", res);
        this.loginService.saveUserDataInLocal(responseData, "");
        // this.navigate(["select-location"], { redirectUrl: "/welcome" });
      });
    } else {

    }
    // 2. check location is set
    if (AppData.currentAddressObj) {
      console.log("Current Address:", AppData.currentAddressObj)
      this.navigateBasedOnDest(data);
    } else {
      console.log("address is not present");
      AppData.deepLinkNavOpt$.next(data);
      this.navigate(["select-location"], { redirectUrl: "/welcome" });
    }
    // 3. load the home screen

    // 4. navigate to that screen
  }

  navigateBasedOnDest(data) {

    console.log("processing notification for navigation");
    console.log("after clicked data: ", data);
    let options = {};

    switch (data.destination) {
      case "order_tracking":
        this.router.navigate(['order-tracking'], { queryParams: { redirectUrl: '/home' }, state: { data: data } })
        options['orderId'] = data.orderId;
        break;

      case "promo_outlet":
        options["promoId"] = data.promoId;
        options["title"] = data.name;
        break;

      case "promo_dish":
        options["promoId"] = data.promoId;
        options["title"] = data.name;
        break;

      case "offer":
        options["name"] = "routeType";
        options["OFFERS"] = "OFFERS";
        break;

      case "rate_order":
        const modalRef = this.modalService.open(
          RatingModalComponent,
          getConfig("RATING_MODAL_CONFIG")
        );
        modalRef.componentInstance.modalObj = data;
        modalRef.componentInstance.passRating.subscribe((res) => {
          console.log(res['rating']);
        })
        break;

      case "dish":
        options["outletId"] = data.outletId;

        break;
      case "outlet":
        options["outletId"] = data.outletId;

        break;
      case "scratch_card":
        options["redirectUrl"] = "/home";
        break;
      case "reward":
        options["redirectUrl"] = "/home";
        break;

      default:
        data.destination = "home";
        break;
    }

    const navigationExtras: NavigationExtras = {
      queryParams: options,
    };
    options["redirectUrl"] = window.location.pathname;
    if (data.destination !== "order_tracking" && data.destination !== "sign_up") {
      this.modalService.dismissAll();
      if (Object.keys(options).length > 0) {
        this.navigate(
          [NAVIGATE_THROUGHT_NOTIFICATION[data.destination]],
          options
        );
      } else {
        this.navigate([
          NAVIGATE_THROUGHT_NOTIFICATION[data.destination],
        ], {});
      }
    }
  }
}